export default __webpack_public_path__ + "static/media/information.4fabdc95.svg";